import { ProjectAnalysesSectionPage } from '@/pages/ProjectAnalysesSectionPage';

export function ProjectAnalysesConsommationPage() {
  return <ProjectAnalysesSectionPage sectionTitle="Consommation" />;
}

